import classNames from "classnames";
import { FC, useRef } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import useToggle from "../../hooks/useToggle";
import styles from "./Hamburger.module.css";
import Menu from "./menu/Menu";

const Hamburger: FC = () => {
  const { isOpen, toggle, close } = useToggle();
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, close);

  return (
    <>
      <div className={classNames(styles.menu, { [styles.open]: isOpen })} ref={ref}>
        <Menu />
      </div>
      <button className={styles.hamburger} onClick={toggle}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </>
  );
};

export default Hamburger;
